import { BusinessInfo } from 'api/account/business/dtos';
import { PublicBusinessInfo } from 'api/unauth/business/dtos';
import { LoadingPage } from 'components/loaders';
import { NotFoundPage } from 'pages/404/404';
import React, { use } from 'react';

type Context = PublicBusinessInfo & {
  hasLoaded: boolean;
  activeSeason?: BusinessInfo['activeSeason'];
};

const BasicBusinessInfoContext = React.createContext<Context>({ hasLoaded: false } as any);

const BasicBusinessInfoProvider = ({
  state,
  loading,
  children,
}: React.PropsWithChildren<{ state?: Partial<Context>; loading?: boolean; noId?: boolean }>) => {
  if (loading) return <LoadingPage />;

  if (!state?.id) return <NotFoundPage />;

  return <BasicBusinessInfoContext value={state as Context}>{children}</BasicBusinessInfoContext>;
};

const useBasicBusinessInfo = () => use(BasicBusinessInfoContext);

export { BasicBusinessInfoProvider, useBasicBusinessInfo };
